<template>
  <div class="reading-container" ref="readingContainer" >
    <v-tabs v-model="tab" class="tabs-container" :class="{ 'fixed-tabs': isScrolled }">
      <v-tab href="#tab-1">Texto</v-tab>
      <v-tab href="#tab-2">Palabras Guardadas</v-tab>
      <v-tab href="#tab-3" v-if="finish">Actividades</v-tab>
      <v-tab disabled>Tiempo {{ timeFormatted }}</v-tab>
    </v-tabs>

    <div  v-show="tab==='tab-1'"  class="info-container">
      <v-card-title>
            <v-row>
              <v-col cols="4">
                <v-text-field class="text--accent-4 mx-0 py-0" readonly label="Autor" :value="textData.author" />
              </v-col>
              <v-col cols="8">
                <v-text-field class="text--accent-4 mx-0 py-0" readonly label="Título" :value="textData.title" />
              </v-col>
              <v-col cols="8">
                <v-text-field v-if="textData.font && textData.font.length > 0" class="text--accent-4 mx-0 py-0" readonly
                  label="Fuente" :value="textData.font" />
              </v-col>
              <v-col cols="2">
                <v-text-field v-if="
                  textData.publicationYear &&
                  textData.publicationYear.length > 0
                " class="text--accent-4 mx-0 py-0" readonly label="Año de publicación"
                  :value="textData.publicationYear" />
              </v-col>
              <v-col cols="2">
                <v-text-field v-if="textData.type && textData.type.length > 0" class="text--accent-4 mx-0 py-0" readonly
                  label="Tipo de texto" :value="textData.type" />
              </v-col>
              <v-col cols="12">
                <v-text-field v-if="textData.description && textData.description.length > 0"
                  class="text--accent-4 mx-0 py-0" readonly label="Descripción" :value="textData.description" />
              </v-col>
              
            </v-row>
          </v-card-title>

          <v-card-title v-if="!finish" class="mx-4 toolbar-container" :class="{ 'fixed-toolbar': isScrolled }">

            <v-row align="center" justify="space-around">
              <v-col >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="changeTextSize('minus')" block color="primary" dark v-bind="attrs" v-on="on">
                      Aa-
                    </v-btn>
                  </template>
                  <span>Disminuir Tamaño Fuente</span>
                </v-tooltip>
              </v-col>
              <v-col >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="changeTextSize('initial')" block color="primary" dark v-bind="attrs" v-on="on">
                      Aa
                    </v-btn>
                  </template>
                  <span>Fuente Normal</span>
                </v-tooltip>
              </v-col>
              <v-col >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="changeTextSize('plus')" block color="primary" dark v-bind="attrs" v-on="on">
                      Aa+
                    </v-btn>
                  </template>
                  <span>Aumentar Tamaño Fuente</span>
                </v-tooltip>
              </v-col>

              <v-col >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="raeSearch" block color="secondary" dark v-bind="attrs" v-on="on">
                      <v-icon dark left> mdi-book-alphabet </v-icon>
                      Buscar RAE
                    </v-btn>
                  </template>
                  <span>Buscar Palabra Diccionario</span>
                </v-tooltip>
              </v-col>

              <v-col >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="setHighLight" block color="secondary" dark v-bind="attrs" v-on="on">
                      <v-icon dark left> mdi-content-save </v-icon>
                      Guardar Palabra
                    </v-btn>
                  </template>
                  <span>Guardar Palabra</span>
                </v-tooltip>
              </v-col>

              <v-col>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="saveProgressToDatabase" block color="secondary" dark v-bind="attrs" v-on="on" 
                          :loading="savingProgress">
                      <v-icon dark left> mdi-database-export </v-icon>
                      Guardar Progreso
                    </v-btn>
                  </template>
                  <span>Guardar progreso para continuar en otro dispositivo</span>
                </v-tooltip>
              </v-col>
              <v-col >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="highLightWord" class="border black--text" block color="rgba(255, 235, 59, 0.3)" dark v-bind="attrs" v-on="on">
                      Resaltar
                    </v-btn>
                  </template>
                  <span>Resaltar Palabra/s</span>
                </v-tooltip>
              </v-col>
              
              <v-col >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn block color="orange" dark v-bind="attrs" v-on="on" @click="finishRead">
                      Siguiente
                    </v-btn>
                  </template>
                  <span>Pasar al apartado de preguntas del texto</span>
                </v-tooltip>
                
              </v-col>
            </v-row>
          </v-card-title>
          
    </div>

    <div class="toolbar-spacer" v-if="isScrolled && !finish"></div>

      <v-tabs-items touchless v-model="tab">
        <v-tab-item value="tab-1">
          <v-card class="mt-4" width="100vw">
            <v-card-text style="background-color: aliceblue">
              <v-container ref="target" v-if="this.activity.activity.minigame === null">
                <v-row class="mt-2 text--primary" v-for="(data, i) in textParagraphs" :key="i">
                  <v-col cols="7" v-if="data.subTitle">
                    <p id="test" class="text-justify" :style="{ fontSize: textSize }" v-html="data.subTitle"></p>
                  </v-col>
                  <v-col cols="11">
                    <div 
                      class="text-justify highlightable-content" 
                      :style="{ fontSize: textSize ,lineHeight: lineHeight  }" 
                      v-html="data.description"
                      @mouseup="handleSelection"
                      :data-paragraph-id="data.id" 
                      @touchend="handleSelection"
                    ></div>

                    <v-text-field
                        class="my-2" 
                        v-if="paragraphQuestion && paragraphQuestion[i] && paragraphQuestion[i].visible" 
                        @click:prepend="toggleQuestionVisibility(i)" 
                        v-model="paragraphQuestion[i].answer"
                        @input="saveState(6)"
                        :prepend-icon="
                          paragraphQuestion[i].answer === ''
                            ? 'mdi-close'
                            : 'mdi-check-all'
                        " 
                        :label="`Pregunta Párrafo ${i + 1}`" 
                      />
                  </v-col>
                  <v-col cols="1" >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon @click="
                          paragraphQuestion[i].visible =
                          !paragraphQuestion[i].visible
                        " :color="
                            paragraphQuestion[i] &&
                              paragraphQuestion[i].answer.length > 0
                              ? 'success'
                              : 'orange'
                          " v-bind="attrs" v-on="on">
                          mdi-comment-question
                        </v-icon>
                      </template>
                      <span>{{
                          paragraphQuestion[i] &&
                            paragraphQuestion[i].answer.length > 0
                            ? "Pregunta Realizada."
                            : "Realizar Pregunta."
                      }}</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-container>
              <v-container v-else ref="target" >
                <div v-if="this.activity.activity.minigame === 'image_minigame'" >
                  <h1 class="text-justify mt-8 mb-4">
                    <strong>Instrucciones: seleccione la imagen que considere que sea asociada al párrafo</strong>
                  </h1>
                  <div v-for="(element, i) in textParagraphs" :key="i" class="mb-6">
                    <v-row class="ma-0 pa-0">
                      <!-- Área del texto del párrafo -->
                      <v-col cols="12" md="7" class="pa-4">
                        <div 
                          class="text-justify highlightable-content" 
                          :style="{ fontSize: textSize, lineHeight: lineHeight }" 
                          v-html="element.description"
                          @mouseup="handleSelection"
                          :data-paragraph-id="element.id" 
                          @touchend="handleSelection"
                        ></div>
                        
                        <v-text-field 
                          class="my-2" 
                          v-if="paragraphQuestion && paragraphQuestion[i] && paragraphQuestion[i].visible" 
                          @click:prepend="toggleQuestionVisibility(i)" 
                          v-model="paragraphQuestion[i].answer"
                          @input="saveState(6)"
                          :prepend-icon="
                            paragraphQuestion[i].answer === ''
                              ? 'mdi-close'
                              : 'mdi-check-all'
                          " 
                          :label="`Pregunta Párrafo ${i + 1}`" 
                        />
                        
                        <!-- Botón de pregunta en móviles (debajo del texto) -->
                        <div class="d-flex d-md-none justify-center">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon 
                                @click="paragraphQuestion[i].visible = !paragraphQuestion[i].visible"
                                :color="paragraphQuestion[i] && paragraphQuestion[i].answer.length > 0 ? 'success' : 'orange'"
                                v-bind="attrs" 
                                v-on="on"
                                size="32"
                              >
                                mdi-comment-question
                              </v-icon>
                            </template>
                            <span>{{
                              paragraphQuestion[i] && paragraphQuestion[i].answer.length > 0
                                ? "Pregunta Realizada."
                                : "Realizar Pregunta."
                            }}</span>
                          </v-tooltip>
                        </div>
                      </v-col>

                      <!-- Icono de pregunta en desktop (columna lateral) -->
                      <v-col cols="1" class="d-none d-md-flex align-center justify-center">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon 
                              @click="paragraphQuestion[i].visible = !paragraphQuestion[i].visible"
                              :color="paragraphQuestion[i] && paragraphQuestion[i].answer.length > 0 ? 'success' : 'orange'"
                              v-bind="attrs" 
                              v-on="on"
                              size="28"
                            >
                              mdi-comment-question
                            </v-icon>
                          </template>
                          <span>{{
                            paragraphQuestion[i] && paragraphQuestion[i].answer.length > 0
                              ? "Pregunta Realizada."
                              : "Realizar Pregunta."
                          }}</span>
                        </v-tooltip>
                      </v-col>

                      <!-- Área del carrusel de imágenes -->
                      <v-col cols="12" md="4" class="pa-4 d-flex flex-column align-center justify-center">
                        <!-- Carrusel mejorado -->
                        <v-carousel 
                            v-model="selectedImages[element.id]" 
                            class="image-carousel-simple"
                            hide-delimiters
                            centered
                            show-arrows-on-hover
                            height="280"
                            :hide-delimiter-background="finish"
                            :show-arrows="!finish"
                            :touchless="finish"
                            :disabled="finish"
                            @change="onImageSelect(element.id, $event)"
                          >
                            <!-- Slide explicativo inicial (no responder) -->
                            <v-carousel-item :value="'no_response'">
                              <div class="image-container d-flex justify-center align-center">
                                <v-card class="instruction-option d-flex align-center justify-center" height="250" width="100%" color="primary" dark>
                                  <div class="text-center">
                                    <v-icon size="48" color="white">mdi-gesture-swipe-horizontal</v-icon>
                                    <h4 class="white--text mt-2">Desliza para seleccionar</h4>
                                    <p class="white--text text-caption mt-1">Si no seleccionas, equivale a "no responder"</p>
                                  </div>
                                </v-card>
                              </div>
                            </v-carousel-item>

                            <!-- Imágenes disponibles -->
                            <v-carousel-item 
                              v-for="(image, index) in images" 
                              :key="index" 
                              :value="image"
                            >
                              <div class="image-container ">
                                <v-img 
                                  :src="image" 
                                  contain
                                  class="contained-image"
                                  max-height="250"
                                >
                                  <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                      <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-img>
                              </div>
                            </v-carousel-item>
                            
                            <!-- Opción: Ninguna imagen -->
                            <v-carousel-item :value="null">
                              <div class="image-container d-flex justify-center align-center">
                                <v-card class="no-image-option d-flex align-center justify-center" height="250" width="100%">
                                  <div class="text-center">
                                    <v-icon size="48" color="grey lighten-1">mdi-image-off</v-icon>
                                    <h4 class="grey--text text--lighten-1 mt-2">Ninguna imagen</h4>
                                  </div>
                                </v-card>
                              </div>
                            </v-carousel-item>
                          </v-carousel>                   
                        
                      </v-col>
                    </v-row>
                  </div>
                </div>
                  <div v-if="this.activity.activity.minigame === 'unordered_text'">
                    <h1 class="text-justify mb-8">
                      <strong>Instrucciones: </strong>
                      <v-icon color="primary">mdi-arrow-up-down</v-icon>
                      Usa los botones de flecha para ordenar los párrafos correctamente
                    </h1>

                    <v-row class="mt-4 text--primary" v-if="!finish">
                      <v-col 
                        cols="12" 
                        class="pa-4 mb-4 elevation-2"
                        v-for="(element, i) in textParagraphs" 
                        :key="i"
                      >
                        <v-row align="center">
                          <!-- Controles de flechas -->
                          <v-col cols="1" class="d-flex flex-column align-center">
                            <v-btn 
                              icon 
                              class="mb-2" 
                              :disabled="i === 0"
                              @click="moveParagraphUp(i)"
                            >
                              <v-icon color="primary">mdi-arrow-up</v-icon>
                            </v-btn>
                            
                            <v-btn 
                              icon 
                              class="mt-2" 
                              :disabled="i === textParagraphs.length - 1"
                              @click="moveParagraphDown(i)"
                            >
                              <v-icon color="primary">mdi-arrow-down</v-icon>
                            </v-btn>
                          </v-col>

                          <!-- Contenido del párrafo -->
                          <v-col cols="9">
                            <div class="paragraph-content">
                              <span class="paragraph-number">{{ i + 1 }}.</span>
                              <div 
                                class="text-justify highlightable-content" 
                                :style="{ fontSize: textSize ,lineHeight: lineHeight }" 
                                v-html="element.description"
                                @mouseup="handleSelection"
                                @touchend="handleSelection"
                                :data-paragraph-id="element.id" 
                              ></div>
                            </div>
                          </v-col>

                          <!-- Pregunta asociada -->
                          <v-col cols="2" class="d-flex align-center">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn 
                                  icon
                                  v-bind="attrs"
                                  v-on="on"
                                  :color="paragraphQuestion && paragraphQuestion[i] && paragraphQuestion[i].answer && paragraphQuestion[i].answer.length > 0 
                                    ? 'success' 
                                    : 'orange'"
                                  @click="toggleQuestionVisibility(i)"
                                >
                                  <v-icon>mdi-comment-question</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ 
                                paragraphQuestion && paragraphQuestion[i] && paragraphQuestion[i].answer && paragraphQuestion[i].answer.length > 0 
                                  ? 'Pregunta respondida' 
                                  : 'Agregar pregunta' 
                              }}</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>

                        <v-text-field 
                          v-if="paragraphQuestion && paragraphQuestion[i] && paragraphQuestion[i].visible"
                          v-model="paragraphQuestion[i].answer"
                          :style="{ fontSize: textSize }"
                          label="Escribe tu pregunta"
                          outlined
                          dense
                          class="mt-4"
                          @input="saveState(12)"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <div  v-else>
                      <v-row>
                        <v-col cols="6">
                          <v-card-title class="d-flex justify-center">
                            <strong>Orden correcto</strong>
                          </v-card-title>
                        </v-col>
                        <v-col cols="6"> 
                          <v-card-title  class="d-flex justify-center">
                              <strong>Orden estudiante</strong>
                            </v-card-title>
                        </v-col>
                      </v-row>
                      <v-row class="text--primary" v-for="(element, i) in textParagraphs" :key="i">

                        <v-col cols="6" >
                          <p class="text-justify"
                            :style="{ fontSize: textSize,lineHeight: lineHeight }"
                            v-html="textParagraphs.find(el => el.id === correctOrder[i]).description">
                          </p>     
                        </v-col>

                        <v-col cols="6" >
                          <p class="text-justify"
                            :style="{ fontSize: textSize,lineHeight: lineHeight ,  color: correctOrder[i] === element.id ? 'green' : 'red' }"
                            v-html="element.description">
                          </p>
                          <v-text-field readonly
                            :prepend-icon="paragraphQuestion[i].answer !== '' ? 'mdi-check-all' : 'mdi-close'"
                            :value="paragraphQuestion[i].answer !== '' ? paragraphQuestion[i].answer : 'No se realizó pregunta.'" />
                        </v-col>
                        
                      </v-row>
                    </div>
                    
                  </div>
              
              </v-container>
            </v-card-text>

            <v-snackbar :color="color" v-model="snackbar">
              {{ text }}

              <template v-slot:action="{ attrs }">
                <v-btn v-bind="attrs" @click="snackbar = false"> OK </v-btn>
              </template>
            </v-snackbar>
          </v-card>
          <ImageModal
            :visible="dialog"
            :imageUrl="selectedImage"
            @close="dialog = false"
          />
        </v-tab-item>

        <v-tab-item value="tab-2">
          <words-table :words="savedWords" />
        </v-tab-item>

        <v-tab-item value="tab-3">
          <student-activity  :id="Number(this.activityId)" :minigame="selectedImages" :activity="activity" :order="this.activity.activity.minigame === 'unordered_text' ? textParagraphs.map(el => el.id) : []"
            :forceFinish="forceFinish" :time="time" :words="savedWords" :paragraph-questions="paragraphQuestion"
            :highLights="highLights" :text="getFullTextArray()" />
        </v-tab-item>
      </v-tabs-items>

    
    </div>
</template>

<script>
import axios from "axios";
import WordsTable from "@/components/students/WordsTable";
import StudentActivity from "@/components/students/activity/unfinish/StudentActivity";
import Swal from "sweetalert2";
import ImageModal from '@/components/UI/ImageModal';
import arrowIcon from '@/assets/icons/arrow-icon.svg';

export default {
  components: { StudentActivity, WordsTable, ImageModal },
  watch: {
    tab() {
      if (this.tab != "tab-1") {
        this.saveState(11);
      }
    }
  },
  data() {
    return {
      initialLoad: true, // Bandera para controlar carga inicial
      isScrolled: false,
      correctOrder: [],
      forceFinish: false,
      interval: null,
      color: "red",
      text: "",
      snackbar: false,
      savedWords: [],
      finish: false,
      tab: "tab-1",
      textData: [],
      textParagraphs: [],
      initial: 17,
      auxInitial: 17,
      textSize: "17px",
      highLights: [],
      canHighLight: false,
      time: 0,
      activityId: null,
      paragraphQuestion: [],
      finishText:true,
      activity:[],
      selectedImages: {}, // Para almacenar la imagen seleccionada por cada párrafo
      images: [], // Para almacenar las imágenes disponibles para seleccionar
      imagesWords: {}, // Para almacenar las palabras e imágenes asociadas
      dialog: false,
      selectedImage: '',
      lineHeight: 1.2,
      arrowIcon,
      isIOS: false,
      currentSelection: null,
      savingProgress: false, 
    };
  },
  computed: {
    timeFormatted() {
      const minutes = Math.floor(this.time / 60);
      const seconds = (this.time % 60).toFixed(2);
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    },
  },
  methods: {

    async saveProgressToDatabase() {
      try {
        this.savingProgress = true;
        
        // Preparar datos para enviar al servidor
        const progressData = {
          paragraph_questions: JSON.stringify(this.paragraphQuestion),
          order: JSON.stringify(this.textParagraphs.map(p => p.id)),
          selected_images: JSON.stringify(this.selectedImages),
          text_size: this.textSize,
          high_lights: JSON.stringify(this.highLights),
          finish: this.finish,
          finish_text: this.finishText,
          saved_words: JSON.stringify(this.savedWords),
          tab: this.tab,
          time: this.time
        };

        // Enviar datos al servidor
        const response = await axios.post(
          `student/activity/reading-progress/${this.activityId}`, 
          progressData
        );

        if (response.data.success) {
          this.showSnackbar('Progreso guardado correctamente en el servidor', 'success');
      
        } else {
          throw new Error(response.data.message || 'Error al guardar progreso');
        }
      } catch (error) {
        console.error("Error al guardar progreso en la base de datos:", error);
        this.showSnackbar(
          `Error al guardar: ${error.response?.data?.message || error.message}`, 
          'error'
        );
      } finally {
        this.savingProgress = false;
      }
    },
    async loadSavedProgress() {
      try {
        // Intentar obtener datos de la base de datos
        const response = await axios.get(`student/activity/reading-progress/${this.activityId}`);
        
        if (response.data.success && response.data.data) {
          const dbData = response.data.data;
          const dbTime = dbData.time || 0;
          
          // Obtener tiempo del localStorage si existe
          let localTime = 0;
          if (localStorage.getItem('activity_time_' + this.activityId)) {
            const timeData = JSON.parse(localStorage.getItem('activity_time_' + this.activityId));
            localTime = timeData.timePased || 0;
          }
          
          // Decidir qué datos usar basado en el tiempo
          if (dbTime > localTime) {
            // Usar datos de la base de datos
            // Convertir datos de la base de datos al formato para localStorage
            const stateData = {
              paragraphQuestion: JSON.parse(dbData.paragraph_questions || '[]'),
              order: JSON.parse(dbData.order || '[]'),
              selectedImages: JSON.parse(dbData.selected_images || '{}'),
              textSize: dbData.text_size || '17px',
              highLights: JSON.parse(dbData.high_lights || '[]'),
              finish: dbData.finish || false,
              finishText: dbData.finish_text || true,
              savedWords: JSON.parse(dbData.saved_words || '[]'),
              tab: dbData.tab || 'tab-1'
            };
            
            // Guardar en localStorage
            localStorage.setItem('activity_state_' + this.activityId, JSON.stringify(stateData));
            
            // Guardar tiempo en localStorage
            const timeData = {
              limitTime: Number(this.activity.activity.time) * 60,
              timePased: dbData.time || 0
            };
            localStorage.setItem('activity_time_' + this.activityId, JSON.stringify(timeData));
            
            // Asignar tiempo al componente
            this.time = dbData.time || 0;
          } 
  
        }
        
        // Cargar desde localStorage (ya sea actualizado con datos del servidor o no)
        this.loadState();
        
      } catch (error) {


        
        // Cargar desde localStorage como fallback
        this.loadState();
      }
    },
    handleScroll() {
      const scrollPosition = window.scrollY;
      const wasScrolled = this.isScrolled; // Guardar estado anterior
      
      // Determinar nuevo estado
      this.isScrolled = scrollPosition > 100;
      
      // Si hay un cambio de estado
      if (wasScrolled !== this.isScrolled) {
        console.log(this.isScrolled ? 'Toolbar fijada' : 'Toolbar normal');
        
        if (this.isScrolled) {
          // Acciones cuando la barra se fija
          if (this.$refs.readingContainer) {
            const containerRect = this.$refs.readingContainer.getBoundingClientRect();
            const containerLeft = containerRect.left + window.scrollX;
            
            // Aplicar mismo padding que el contenedor
            document.querySelectorAll('.fixed-tabs, .fixed-toolbar').forEach(el => {
              el.style.left = `${containerLeft}px`;
              el.style.width = `${containerRect.width}px`;
            });
          }
        } else {
          // Acciones cuando la barra vuelve a normal
          // Limpiar los estilos inline aplicados
          document.querySelectorAll('.toolbar-container, .tabs-container').forEach(el => {
            el.style.left = '';
            el.style.width = '';
          });
        }
      } else if (this.isScrolled) {
        // Actualizar posición mientras sigue scrolled
        // (para manejar resize u otros cambios mientras está fija)
        if (this.$refs.readingContainer) {
          const containerRect = this.$refs.readingContainer.getBoundingClientRect();
          const containerLeft = containerRect.left + window.scrollX;
          
          document.querySelectorAll('.fixed-tabs, .fixed-toolbar').forEach(el => {
            el.style.left = `${containerLeft}px`;
            el.style.width = `${containerRect.width}px`;
          });
        }
      }
    },
    getFullTextArray() {
      const textArray = [];
      
      // 1. Agregar título del texto
      if (this.textData.title?.trim()) {
        textArray.push(this.textData.title.trim());
      }

      // 2. Extraer texto de los párrafos (sin HTML)
      this.textParagraphs.forEach(paragraph => {
        // Convertir HTML a texto plano
        const div = document.createElement('div');
        div.innerHTML = paragraph.description;
        const plainText = div.textContent || '';
        
        if (plainText.trim()) {
          textArray.push(plainText.trim());
        }
      });

      return textArray;
    },
    toggleQuestionVisibility(index) {
      // Verificar que paragraphQuestion[index] existe antes de modificarlo
      if (this.paragraphQuestion && this.paragraphQuestion[index]) {
        // Si la propiedad visible no existe, la inicializamos
        if (typeof this.paragraphQuestion[index].visible === 'undefined') {
          this.$set(this.paragraphQuestion[index], 'visible', true);
        } else {
          this.paragraphQuestion[index].visible = !this.paragraphQuestion[index].visible;
        }
        this.saveState(12);
      } else {
        console.error(`No se encontró paragraphQuestion para el índice ${index}`);
        // Intentar inicializar si es necesario
        this.initializeParagraphQuestion(index);
      }
    },

    // Método para inicializar un paragraphQuestion faltante
    initializeParagraphQuestion(index) {
      // Verificar que tenemos datos válidos
      if (!this.textParagraphs || !this.textParagraphs[index]) {
        console.error('No se pudo inicializar paragraphQuestion: datos de párrafo no válidos');
        return;
      }

      // Si paragraphQuestion no existe, lo inicializamos como array
      if (!this.paragraphQuestion) {
        this.paragraphQuestion = [];
      }

      // Crear un objeto de pregunta para este índice
      const paragraphId = this.textParagraphs[index].id;
      const textId = this.textData && this.textData.id ? this.textData.id : null;

      // Usar $set para asegurar reactividad
      this.$set(this.paragraphQuestion, index, {
        id: paragraphId,
        answer: "",
        textId: textId,
        visible: true, // Lo hacemos visible inmediatamente
      });

      console.log(`paragraphQuestion inicializado para índice ${index}`);
    },
    moveParagraphUp(index) {
      if (index > 0) {
        // Mover párrafo
        const movedPara = this.textParagraphs.splice(index, 1)[0];
        this.textParagraphs.splice(index - 1, 0, movedPara);
        
        // Mover pregunta correspondiente
        const movedQuestion = this.paragraphQuestion.splice(index, 1)[0];
        this.paragraphQuestion.splice(index - 1, 0, movedQuestion);
        

        this.saveState();
      }
    },
    
    moveParagraphDown(index) {
      if (index < this.textParagraphs.length - 1) {
        // Mover párrafo
        const movedPara = this.textParagraphs.splice(index, 1)[0];
        this.textParagraphs.splice(index + 1, 0, movedPara);
        
        // Mover pregunta correspondiente
        const movedQuestion = this.paragraphQuestion.splice(index, 1)[0];
        this.paragraphQuestion.splice(index + 1, 0, movedQuestion);
        
        
        this.saveState();
      }
    },
    
    onImageSelect(paragraphId, imageUrl) {
      if (this.initialLoad) return; // No hacer nada durante carga inicial

      this.$set(this.selectedImages, paragraphId, imageUrl);
      if (paragraphId !== null && imageUrl !== null) {
        this.saveState(14); // Guardar estado cuando se selecciona una imagen
      }
    },
    async finishRead() {
      this.finishText=false;
      await Swal.fire({
        title: "¿Desea finalizar la lectura?",
        text: "Pasará a responder las prenguntas para termianar la actividad",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Volver",
        confirmButtonText: "Sí!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await Swal.fire(
            "Completada!",
            "La lectura ha sido completada..",
            "success"
          );

          this.finish = true;
          this.tab = "tab-3";

          const progressData = {
            paragraph_questions: JSON.stringify(this.paragraphQuestion),
            order: JSON.stringify(this.textParagraphs.map(p => p.id)),
            selected_images: JSON.stringify(this.selectedImages),
            text_size: this.textSize,
            high_lights: JSON.stringify(this.highLights),
            finish: this.finish,
            finish_text: this.finishText,
            saved_words: JSON.stringify(this.savedWords),
            tab: this.tab,
            time: this.time
          };
          // Enviar datos al servidor
          await axios.post(
            `student/activity/reading-progress/${this.activityId}`, 
            progressData
          );

  
          this.startTimer();
          this.saveState(15);
        } else {
          this.finishText=true;
          // Si el usuario cancela, reanuda el intervalo
          this.saveState(16);
          this.startTimer();
        }
      });
    },
    setHighLight() {
      this.canHighLight = true;
      this.saveWord();
    },
    changeTextSize(statement) {
      if (statement === "plus") {
        this.initial++;
        this.textSize = `${this.initial}px`;
        this.lineHeight= this.lineHeight+0.05;
      }

      if (statement === "minus") {
        if (this.initial > 1) {
          this.initial--;
          this.textSize = `${this.initial}px`;
          this.lineHeight= this.lineHeight+0.05;
        }
      }

      if (statement === "initial") {
        this.initial = this.auxInitial;
        this.textSize = `${this.initial}px`;
        this.lineHeight= 1.2;
      }
      this.saveState(17);
    },
    saveState(number) {
      console.log(number);
      if (!this.activityId) {
        console.error("Activity ID is not defined");
        return;
      }

      try {

        const cleanHighlights = this.highLights.map(highlight => ({
          text: highlight.text,
          paragraphId: highlight.paragraphId,
          occurrenceIndex: highlight.occurrenceIndex
        }));

        // Asegurarse de que paragraphQuestion es serializable
        const cleanParagraphQuestion = this.paragraphQuestion.map(q => {
          return {
            id: q.id || null,
            answer: q.answer || "",
            textId: q.textId || null,
            visible: Boolean(q.visible) // Convertir a booleano para asegurar tipo consistente
          };
        });

        const state = {
          paragraphQuestion: cleanParagraphQuestion,
          order: this.textParagraphs.map(p => p.id),
          selectedImages: this.selectedImages,
          textSize: this.textSize,
          highLights: cleanHighlights,
          finish: this.finish,
          finishText: this.finishText,
          savedWords: this.savedWords,
          tab: this.tab
        };

        console.log(state)

        localStorage.setItem('activity_state_' + this.activityId, JSON.stringify(state));
      } catch (error) {
        console.error("Error al guardar estado:", error);
      }
    },

    loadState() {
      if (!this.activityId) {
        console.error("Activity ID is not defined");
        return;
      }
      
      try {
        const state = localStorage.getItem('activity_state_' + this.activityId);
        if (state) {
          const parsedState = JSON.parse(state);
          // Validar datos de paragraphQuestion 
          if (Array.isArray(parsedState.paragraphQuestion)) {
            // Asegurarnos de que cada elemento tiene la estructura correcta
            this.paragraphQuestion = parsedState.paragraphQuestion.map((q, index) => {
              return {
                id: q.id || (this.textParagraphs[index] ? this.textParagraphs[index].id : null),
                answer: q.answer || "",
                textId: q.textId || (this.textData ? this.textData.id : null),
                visible: Boolean(q.visible) // Convertir a booleano explícitamente
              };
            });
          } else {
            // Si no hay datos válidos, inicializar array vacío
            this.paragraphQuestion = [];
            this.initializeAllParagraphQuestions();
          }
          
          this.selectedImages = parsedState.selectedImages || {};
      this.textSize = parsedState.textSize || '17px';
      this.finish = parsedState.finish || false;
      this.savedWords = parsedState.savedWords || [];
      this.tab = parsedState.tab || 'tab-1';

      // Cargar resaltados
      if (Array.isArray(parsedState.highLights)) {
        this.highLights = parsedState.highLights;
      } else {
        this.highLights = [];
      }

      // Restaurar orden de párrafos
      if (parsedState.order && parsedState.order.length > 0) {
        const paragraphMap = {};
        this.textParagraphs.forEach(p => {
          paragraphMap[p.id] = p;
        });
        
        const orderedParagraphs = [];
        parsedState.order.forEach(id => {
          if (paragraphMap[id]) {
            orderedParagraphs.push(paragraphMap[id]);
            delete paragraphMap[id];
          }
        });
        
        Object.values(paragraphMap).forEach(p => {
          orderedParagraphs.push(p);
        });
        
        if (orderedParagraphs.length > 0) {
          this.textParagraphs = orderedParagraphs;
        }
      }

      // Restaurar resaltados en el siguiente tick
      this.$nextTick(() => {
        this.applyStoredHighlights();
        this.initialLoad = false;
      });

    } else {
      console.warn("No state found for activity ID:", this.activityId);
      this.initialLoad = false;
    }
  } catch (error) {
    console.error("Error al cargar estado:", error);
    this.initialLoad = false;
  }
},
   
    // 5. Método para inicializar todos los paragraphQuestions
    initializeAllParagraphQuestions() {
      if (!this.textParagraphs || !this.textParagraphs.length) {
        console.warn("No hay párrafos disponibles para inicializar preguntas");
        return;
      }

      // Si paragraphQuestion no existe, inicializarlo como array vacío
      if (!this.paragraphQuestion) {
        this.paragraphQuestion = [];
      }

      // Crear un mapa de las preguntas existentes por ID de párrafo
      const existingQuestionsMap = {};
      this.paragraphQuestion.forEach(question => {
        if (question && question.id) {
          existingQuestionsMap[question.id] = question;
        }
      });

      // Crear o conservar preguntas para cada párrafo
      const updatedQuestions = [];
      
      this.textParagraphs.forEach((paragraph, index) => {
        // Si ya existe una pregunta para este párrafo, conservarla
        if (existingQuestionsMap[paragraph.id]) {
          updatedQuestions[index] = existingQuestionsMap[paragraph.id];
        } 
        // Si no existe, crear una nueva
        else {
          updatedQuestions[index] = {
            id: paragraph.id,
            answer: "",
            textId: this.textData && this.textData.id ? this.textData.id : null,
            visible: false
          };
        }
      });

      // Actualizar el array de preguntas
      this.paragraphQuestion = updatedQuestions;

      console.log(`${this.paragraphQuestion.length} preguntas de párrafos inicializadas/actualizadas`);
    },
    async getText() {
      try {
        const response = await axios.get(
          "student/activity/text/" + this.activityId
        );
        const { text, paragraph } = response.data;
        this.textData = text;
        this.textParagraphs = paragraph;
        this.imagesWords = JSON.parse(text.images_words); // Almacenar el JSON images_words


        // Subrayar las palabras en el texto y agregar enlaces a las imágenes
        this.textParagraphs = this.textParagraphs.map(paragraph => {
          for (const word in this.imagesWords) {
            const escapedWord = this.escapeRegExp(word);
            const regex = new RegExp(`\\b${escapedWord}\\b`, 'gi');
            const linkTag = `<span class="image-link" data-image="${this.imagesWords[word]}" style="position: relative; z-index: 10; color: blue; text-decoration: underline;">${word}</span>`;
            paragraph.description = paragraph.description.replace(regex, linkTag);
          }

          return paragraph;
        });
      
        // Inicializar con valores por defecto
        this.paragraphQuestion = [];
        this.initializeAllParagraphQuestions();
      
        // Procesar los párrafos
        this.textParagraphs.forEach(paragraph => {
          // Solo agregar a correctOrder si no está presente
          if (!this.correctOrder.includes(paragraph.id)) {
            this.correctOrder.push(paragraph.id);
          }

          // Agregar imagen si no está ya en la lista
          if (paragraph.image && !this.images.includes(paragraph.image)) {
            this.images.push(paragraph.image);
          }

          if (this.activity.activity.minigame === 'image_minigame' && !Object.prototype.hasOwnProperty.call(this.selectedImages, paragraph.id)) {
            this.$set(this.selectedImages, paragraph.id, null);
          }// Asegurar que selectedImages tenga una entrada para el párrafo
        
        });

         
        
        if (this.activity.activity.minigame === 'unordered_text') {
          this.textParagraphs.sort(() => 0.5 - Math.random());
        }

      } catch (e) {
        console.log(e);
      }
    },
    escapeRegExp(string) {
      if (!string || typeof string !== 'string') return '';
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
                  .replace(/\s+/g, '\\s+'); // Hacer que los espacios sean flexibles
    },
    searchWord(word) {
      return this.savedWords.find((data) => data === word);
    },
    showImageModal(imageUrl) {
      this.selectedImage = imageUrl;
      this.dialog = true;
    },
    
    detectIOS() {
      this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      console.log("¿Dispositivo iOS?:", this.isIOS);
    },

    async checkExistingReply() {
      try {
        const response = await axios.get(`student/reply/${this.activityId}`);
        
        if (response.data.ok && response.data.reply) {
          // Si hay una respuesta, redirigir al estudiante o mostrar un mensaje
          Swal.fire({
            title: 'Actividad ya completada',
            text: 'Ya has completado esta actividad anteriormente.',
            icon: 'info',
            confirmButtonText: 'Ver resultados',
            showCancelButton: true,
            cancelButtonText: 'Volver'
          }).then((result) => {
            if (result.isConfirmed) {
              // Opción 1: Mostrar directamente los resultados
              this.$router.push('/estudiante/finalizada/' + this.activityId);
            } else {
              // Opción 2: Redirigir a la lista de actividades
              this.$router.push('/estudiante/asignaturas');
            }
          });
        }
      } catch (error) {
        console.error('Error al verificar respuesta existente:', error);
      }
    },

    // Mejorar manejo de selección para capturar texto seleccionado en iOS
    handleSelection() {
      const selection = window.getSelection();
      if (selection && !selection.isCollapsed) {
        // Guardar la selección actual
        this.currentSelection = {
          text: selection.toString().trim(),
          range: selection.getRangeAt(0)
        };
        console.log("Texto seleccionado:", this.currentSelection.text);
      }
    },
    highLightWord() {
      try {
        console.log('=== INICIANDO RESALTADO ===');
        
        // 1. Obtener el texto seleccionado desde currentSelection
        const selection = window.getSelection();
        let selectedText = '';
        let range = null;

        if (selection && !selection.isCollapsed) {
          selectedText = selection.toString().trim();
          range = selection.getRangeAt(0);
        } else if (this.currentSelection && this.currentSelection.text) {
          selectedText = this.currentSelection.text;
          range = this.currentSelection.range;
        } else {
          this.showSnackbar('Seleccione texto primero', 'orange');
          return;
        }

        if (!selectedText) {
          this.showSnackbar('Selección vacía', 'orange');
          return;
        }

        console.log('Texto seleccionado:', selectedText);

        // 2. Verificar que el texto está contenido en un solo párrafo
        const paragraphValidation = this.validateParagraphSelection(range);
        if (!paragraphValidation.isValid) {
          this.showSnackbar(paragraphValidation.error, 'red');
          return;
        }

        const paragraphId = paragraphValidation.paragraphId;
        console.log('Párrafo ID:', paragraphId);

        // 3. Calcular la ocurrencia del texto en el párrafo
        const occurrenceIndex = this.calculateOccurrenceIndex(paragraphId, selectedText, range);
        if (occurrenceIndex === -1) {
          this.showSnackbar('No se pudo determinar la posición del texto', 'red');
          return;
        }

        console.log('Índice de ocurrencia:', occurrenceIndex);

        // 4. Verificar si ya existe este resaltado
        const existingHighlight = this.highLights.find(h => 
          h.paragraphId == paragraphId && 
          h.text === selectedText && 
          h.occurrenceIndex === occurrenceIndex
        );

        if (existingHighlight) {
          this.showSnackbar('Este texto ya está resaltado', 'orange');
          return;
        }

        // 5. Aplicar el resaltado al HTML
        const wasApplied = this.applyHighlightToHTML(paragraphId, selectedText, occurrenceIndex);
        if (!wasApplied) {
          this.showSnackbar('No se pudo aplicar el resaltado', 'red');
          return;
        }

        // 6. Guardar los datos del resaltado
        this.highLights.push({
          text: selectedText,
          paragraphId: paragraphId,
          occurrenceIndex: occurrenceIndex
        });

        // 7. Guardar estado y mostrar mensaje de éxito
        this.saveState(18);
        this.showSnackbar('Texto resaltado correctamente', 'success');

        // Limpiar selección
        selection.removeAllRanges();
        this.currentSelection = null;

        console.log('=== RESALTADO COMPLETADO ===');

      } catch (error) {
        console.error('Error en highLightWord:', error);
        this.showSnackbar('Error inesperado al resaltar', 'red');
      }
    },

    // Método auxiliar: Validar que la selección está en un solo párrafo
    validateParagraphSelection(range) {
      if (!range) {
        return {
          isValid: false,
          error: 'No hay rango de selección válido'
        };
      }

      // Buscar el contenedor del párrafo
      let container = range.commonAncestorContainer;
      
      // Si es un nodo de texto, subir al elemento padre
      if (container.nodeType === Node.TEXT_NODE) {
        container = container.parentNode;
      }

      // Buscar hacia arriba hasta encontrar el elemento con data-paragraph-id
      while (container && !container.dataset?.paragraphId) {
        container = container.parentNode;
        
        // Evitar salirse del documento
        if (container === document.body || !container) {
          break;
        }
      }

      if (!container?.dataset?.paragraphId) {
        return {
          isValid: false,
          error: 'El texto debe estar dentro de un párrafo'
        };
      }

      return {
        isValid: true,
        paragraphId: container.dataset.paragraphId,
        container: container
      };
    },

    calculateOccurrenceIndex(paragraphId, selectedText, range) {
      try {
        console.log('=== CALCULANDO OCURRENCIA SIMPLE ===');
        console.log('Párrafo ID:', paragraphId);
        console.log('Texto seleccionado:', selectedText);
        
        // PASO 1: Encontrar el párrafo en nuestros datos
        const paragraph = this.textParagraphs.find(p => p.id == paragraphId);
        if (!paragraph) {
          console.error('Párrafo no encontrado:', paragraphId);
          return -1;
        }

        const originalHTML = paragraph.description;
        console.log('HTML original:', originalHTML);

        // PASO 2: Limpiar HTML en variable temporal (NO modificar DOM)
        const cleanHTML = this.removeAllSpansForCalculation(originalHTML);
        console.log('HTML limpio (temp):', cleanHTML);

        // PASO 3: Convertir a texto plano para cálculos
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = cleanHTML;
        const plainText = tempDiv.textContent || tempDiv.innerText || '';
        console.log('Texto plano:', plainText);

        // PASO 4: Calcular posición de la selección en texto plano
        const selectionPositionInPlainText = this.getSelectionPositionInPlainText(range);
        if (selectionPositionInPlainText === -1) {
          console.error('No se pudo calcular posición de selección');
          return -1;
        }
        console.log('Posición de selección en texto plano:', selectionPositionInPlainText);

        // PASO 5: Contar ocurrencias ANTES de la posición
        const textBeforeSelection = plainText.substring(0, selectionPositionInPlainText);
        console.log('Texto antes de selección:', textBeforeSelection);

        let occurrenceCount = 0;
        const searchTextLower = selectedText.toLowerCase();
        const beforeTextLower = textBeforeSelection.toLowerCase();
        
        let pos = beforeTextLower.indexOf(searchTextLower);
        while (pos !== -1) {
          console.log(`Ocurrencia ${occurrenceCount + 1} encontrada en posición ${pos}`);
          occurrenceCount++;
          pos = beforeTextLower.indexOf(searchTextLower, pos + 1);
        }
        
        console.log('Total ocurrencias antes de selección:', occurrenceCount);
        console.log('=== FIN CÁLCULO OCURRENCIA ===');
        
        return occurrenceCount;
        
      } catch (error) {
        console.error('Error calculando ocurrencia:', error);
        return -1;
      }
    },

    // Función auxiliar SIMPLE: Remover TODOS los spans para cálculo (no modifica DOM)
    removeAllSpansForCalculation(html) {
      try {
        console.log('Removiendo todos los spans para cálculo...');
        
        // Crear elemento temporal
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        
        // Buscar TODOS los spans (highlight-word, image-link, cualquier span)
        const allSpans = tempDiv.querySelectorAll('span');
        
        console.log(`Encontrados ${allSpans.length} spans para remover en cálculo`);
        
        // Reemplazar cada span por su contenido de texto
        allSpans.forEach((span, index) => {
          const content = span.textContent;
          console.log(`Removiendo span ${index + 1}: "${content}"`);
          
          const textNode = document.createTextNode(content);
          span.parentNode.replaceChild(textNode, span);
        });
        
        return tempDiv.innerHTML;
        
      } catch (error) {
        console.error('Error removiendo spans para cálculo:', error);
        return html;
      }
    },

    // Función auxiliar SIMPLE: Calcular posición de selección en texto plano
    getSelectionPositionInPlainText(range) {
      try {
        console.log('Calculando posición de selección en texto plano...');
        
        // Encontrar el contenedor del párrafo
        let container = range.startContainer;
        while (container && !container.dataset?.paragraphId) {
          container = container.parentNode;
        }
        
        if (!container) {
          console.error('No se encontró contenedor de párrafo');
          return -1;
        }
        
        // Crear range desde el inicio del párrafo hasta el inicio de la selección
        const tempRange = document.createRange();
        tempRange.setStart(container, 0);
        tempRange.setEnd(range.startContainer, range.startOffset);
        
        // Obtener HTML antes de la selección
        const htmlBefore = this.getHTMLFromRange(tempRange);
        tempRange.detach();
        
        console.log('HTML antes de selección:', htmlBefore);
        
        // Limpiar spans del HTML antes de selección
        const cleanHTMLBefore = this.removeAllSpansForCalculation(htmlBefore);
        console.log('HTML limpio antes de selección:', cleanHTMLBefore);
        
        // Convertir a texto plano
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = cleanHTMLBefore;
        const plainTextBefore = tempDiv.textContent || tempDiv.innerText || '';
        
        console.log('Texto plano antes de selección:', plainTextBefore);
        console.log('Longitud (posición):', plainTextBefore.length);
        
        return plainTextBefore.length;
        
      } catch (error) {
        console.error('Error calculando posición en texto plano:', error);
        return -1;
      }
    },





// Método auxiliar CORREGIDO: Aplicar resaltado al HTML
applyHighlightToHTML(paragraphId, selectedText, occurrenceIndex) {
  try {
    console.log('=== APLICANDO RESALTADO (CORREGIDO) ===');
    console.log('Párrafo ID:', paragraphId);
    console.log('Texto:', selectedText);
    console.log('Índice de ocurrencia:', occurrenceIndex);
    
    // Encontrar el párrafo en nuestros datos
    const paragraphIndex = this.textParagraphs.findIndex(p => p.id == paragraphId);
    if (paragraphIndex === -1) {
      console.error('Párrafo no encontrado en datos:', paragraphId);
      return false;
    }

    const originalHTML = this.textParagraphs[paragraphIndex].description;
    console.log('HTML original:', originalHTML);

    // Encontrar la posición exacta donde insertar el resaltado
    const insertPosition = this.findInsertPositionInHTML(originalHTML, selectedText, occurrenceIndex);
    if (insertPosition === -1) {
      console.error('No se pudo encontrar posición para insertar resaltado');
      return false;
    }
    
    console.log('Posición de inserción encontrada:', insertPosition);
    
    // Insertar el span de resaltado en la posición encontrada
    const newHTML = this.insertHighlightSpanAtPosition(originalHTML, selectedText, insertPosition);
    if (newHTML === originalHTML) {
      console.error('No se pudo insertar el span de resaltado');
      return false;
    }
    
    console.log('HTML con nuevo resaltado:', newHTML);
    
    // Actualizar el párrafo
    this.$set(this.textParagraphs[paragraphIndex], 'description', newHTML);
    
    console.log('=== RESALTADO APLICADO ===');
    return true;
    
  } catch (error) {
    console.error('Error aplicando resaltado:', error);
    return false;
  }
},


// Método auxiliar: Obtener HTML de un range
getHTMLFromRange(range) {
  try {
    const container = document.createElement('div');
    container.appendChild(range.cloneContents());
    return container.innerHTML;
  } catch (error) {
    console.error('Error obteniendo HTML del range:', error);
    return '';
  }
},

// 1. FUNCIÓN PRINCIPAL - Encontrar posición de inserción
findInsertPositionInHTML(html, searchText, occurrenceIndex) {
  try {
    const mapping = this.createHTMLToPlainMapping(html);
    const occurrences = this.findOccurrencesInPlainText(mapping.plainText, searchText);
    
    if (occurrenceIndex >= occurrences.length) {
      console.error(`Ocurrencia ${occurrenceIndex} no existe. Total: ${occurrences.length}`);
      return -1;
    }
    
    const plainStartPos = occurrences[occurrenceIndex].start;
    return this.convertPlainPositionToHTML(plainStartPos, mapping);
    
  } catch (error) {
    console.error('Error en búsqueda:', error);
    return -1;
  }
},

// 2. CREAR MAPEO HTML ↔ TEXTO PLANO
createHTMLToPlainMapping(html) {
  const mapping = {
    plainText: '',
    plainToHtml: [],
    htmlToPlain: []
  };
  
  let htmlIndex = 0;
  let plainIndex = 0;
  
  while (htmlIndex < html.length) {
    const char = html[htmlIndex];
    
    if (char === '<') {
      const tagEndIndex = this.findHTMLTagEnd(html, htmlIndex);
      
      for (let i = htmlIndex; i < tagEndIndex; i++) {
        mapping.htmlToPlain[i] = plainIndex;
      }
      
      htmlIndex = tagEndIndex;
    } else {
      mapping.plainText += char;
      mapping.plainToHtml[plainIndex] = htmlIndex;
      mapping.htmlToPlain[htmlIndex] = plainIndex;
      
      htmlIndex++;
      plainIndex++;
    }
  }
  
  return mapping;
},

// 3. ENCONTRAR FINAL DE TAG HTML
findHTMLTagEnd(html, startIndex) {
  let index = startIndex;
  if (html[index] !== '<') return index + 1;
  
  let inQuotes = false;
  let quoteChar = '';
  
  while (index < html.length) {
    const char = html[index];
    
    if ((char === '"' || char === "'") && !inQuotes) {
      inQuotes = true;
      quoteChar = char;
    } else if (char === quoteChar && inQuotes) {
      inQuotes = false;
      quoteChar = '';
    }
    
    if (char === '>' && !inQuotes) {
      return index + 1;
    }
    
    index++;
  }
  
  return html.length;
},

// 4. BUSCAR OCURRENCIAS EN TEXTO PLANO
findOccurrencesInPlainText(plainText, searchText) {
  const occurrences = [];
  const searchLower = searchText.toLowerCase();
  const textLower = plainText.toLowerCase();
  
  let searchStart = 0;
  while (searchStart <= plainText.length - searchText.length) {
    const foundIndex = textLower.indexOf(searchLower, searchStart);
    if (foundIndex === -1) break;
    
    occurrences.push({
      start: foundIndex,
      end: foundIndex + searchText.length,
      text: plainText.substring(foundIndex, foundIndex + searchText.length)
    });
    
    searchStart = foundIndex + 1;
  }
  
  return occurrences;
},

// 5. CONVERTIR POSICIÓN DE TEXTO PLANO A HTML
convertPlainPositionToHTML(plainPosition, mapping) {
  if (plainPosition < 0 || plainPosition >= mapping.plainToHtml.length) {
    return -1;
  }
  return mapping.plainToHtml[plainPosition];
},

// 6. INSERTAR SPAN DE RESALTADO (SIMPLIFICADO)
insertHighlightSpanAtPosition(html, text, position) {
  try {
    if (position < 0 || position > html.length) {
      return html;
    }
    
    const mapping = this.createHTMLToPlainMapping(html);
    const plainStartPos = mapping.htmlToPlain[position];
    const plainEndPos = plainStartPos + text.length;
    
    // Verificar si está fragmentado
    if (this.isTextFragmentedByHTML(html, position, text.length, mapping)) {
      return this.insertFragmentedTextHighlight(html, text, plainStartPos, plainEndPos, mapping);
    } else {
      return this.insertSimpleTextHighlight(html, text, position);
    }
    
  } catch (error) {
    console.error('Error en inserción:', error);
    return html;
  }
},

// 7. DETECTAR SI TEXTO ESTÁ FRAGMENTADO
isTextFragmentedByHTML(html, startPos, textLength, mapping) {
  try {
    const endPos = this.findCorrespondingHTMLEndPosition(startPos, textLength, mapping, html);
    const htmlFragment = html.substring(startPos, endPos);
    return /<[^>]+>/g.test(htmlFragment);
  } catch (error) {
    return true;
  }
},

// 8. ENCONTRAR POSICIÓN HTML FINAL
findCorrespondingHTMLEndPosition(startPos, textLength, mapping, html) {
  const plainStartPos = mapping.htmlToPlain[startPos];
  const targetPlainEndPos = plainStartPos + textLength;
  
  for (let plainPos = targetPlainEndPos - 1; plainPos >= 0; plainPos--) {
    if (mapping.plainToHtml[plainPos] !== undefined) {
      let htmlPos = mapping.plainToHtml[plainPos] + 1;
      let plainCount = plainPos + 1;
      
      while (htmlPos < html.length && plainCount < targetPlainEndPos) {
        if (html[htmlPos] === '<') {
          htmlPos = this.findHTMLTagEnd(html, htmlPos);
        } else {
          htmlPos++;
          plainCount++;
        }
      }
      
      return htmlPos;
    }
  }
  
  return html.length;
},

// 9. INSERCIÓN SIMPLE
insertSimpleTextHighlight(html, text, position) {
  const highlightSpan = `<span class="highlight-word" style="background-color: rgba(255, 235, 59, 0.5); border-radius: 3px; padding: 1px 2px;">${text}</span>`;
  const beforeText = html.substring(0, position);
  const afterText = html.substring(position + text.length);
  return beforeText + highlightSpan + afterText;
},

// 10. INSERCIÓN FRAGMENTADA
insertFragmentedTextHighlight(html, searchText, plainStartPos, plainEndPos, mapping) {
  try {
    const htmlStartPos = mapping.plainToHtml[plainStartPos];
    const htmlEndPos = this.findCorrespondingHTMLEndPosition(htmlStartPos, searchText.length, mapping, html);
    
    const htmlFragment = html.substring(htmlStartPos, htmlEndPos);
    const highlightSpan = `<span class="highlight-word" style="background-color: rgba(255, 235, 59, 0.5); border-radius: 3px; padding: 1px 2px;">${htmlFragment}</span>`;
    
    const beforeText = html.substring(0, htmlStartPos);
    const afterText = html.substring(htmlEndPos);
    
    return beforeText + highlightSpan + afterText;
    
  } catch (error) {
    console.error('Error en inserción fragmentada:', error);
    return html;
  }
},

// 11. LIMPIAR RESALTADOS EXISTENTES (CORREGIDO PARA PRESERVAR IMAGE-LINKS)
removeHighlightSpansFromHTML(html) {
  try {
    console.log('Removiendo SOLO spans de highlight, preservando image-links...');
    
    // Usar regex más específica que solo remueve spans de highlight
    // y preserva otros spans como image-link
    let cleanHTML = html;
    
    // Patrón que busca específicamente spans con clase highlight-word
    const highlightSpanPattern = /<span\s+class="highlight-word"[^>]*>/gi;
    
    // Remover tags de apertura de highlight
    cleanHTML = cleanHTML.replace(highlightSpanPattern, '');
    
    // Contar spans de highlight para saber cuántos </span> remover
    const highlightMatches = html.match(highlightSpanPattern) || [];
    const highlightCount = highlightMatches.length;
    
    // Remover la cantidad correcta de </span> (empezando desde el final)
    for (let i = 0; i < highlightCount; i++) {
      const lastSpanIndex = cleanHTML.lastIndexOf('</span>');
      if (lastSpanIndex !== -1) {
        cleanHTML = cleanHTML.substring(0, lastSpanIndex) + 
                   cleanHTML.substring(lastSpanIndex + 7); // 7 = length of '</span>'
      }
    }
    
    console.log('HTML limpiado (preservando image-links):', cleanHTML);
    return cleanHTML;
    
  } catch (error) {
    console.error('Error removiendo spans de highlight:', error);
    return html;
  }
},

// 12. APLICAR RESALTADOS GUARDADOS (SIMPLIFICADO)
applyStoredHighlights() {
  if (!this.highLights || this.highLights.length === 0) {
    return;
  }

  console.log(`=== APLICANDO ${this.highLights.length} RESALTADOS GUARDADOS ===`);

  try {
    // Limpiar resaltados existentes (preservando image-links)
    this.cleanExistingHighlights();

    // Agrupar por párrafo y ordenar
    const highlightsByParagraph = {};
    this.highLights.forEach(highlight => {
      const paragraphId = highlight.paragraphId;
      if (!highlightsByParagraph[paragraphId]) {
        highlightsByParagraph[paragraphId] = [];
      }
      highlightsByParagraph[paragraphId].push(highlight);
    });

    // Aplicar resaltados por párrafo
    Object.keys(highlightsByParagraph).forEach(paragraphId => {
      const highlights = highlightsByParagraph[paragraphId];
      highlights.sort((a, b) => a.occurrenceIndex - b.occurrenceIndex);
      this.restoreParagraphHighlights(paragraphId, highlights);
    });

    console.log('=== RESALTADOS APLICADOS EXITOSAMENTE ===');

  } catch (error) {
    console.error('Error aplicando resaltados:', error);
    // Si hay error, limpiar datos para evitar problemas futuros
    this.highLights = [];
    this.saveState();
  }
},

// 13. LIMPIAR RESALTADOS EXISTENTES
cleanExistingHighlights() {
  this.textParagraphs.forEach((paragraph, index) => {
    const originalHTML = paragraph.description;
    const cleanHTML = this.removeHighlightSpansFromHTML(originalHTML);
    
    if (cleanHTML !== originalHTML) {
      this.$set(this.textParagraphs[index], 'description', cleanHTML);
    }
  });
},

// 14. RESTAURAR RESALTADOS DE PÁRRAFO
restoreParagraphHighlights(paragraphId, highlights) {
  try {
    const paragraphIndex = this.textParagraphs.findIndex(p => p.id == paragraphId);
    if (paragraphIndex === -1) {
      console.warn(`Párrafo ${paragraphId} no encontrado`);
      return;
    }

    let currentHTML = this.textParagraphs[paragraphIndex].description;

    highlights.forEach((highlight, index) => {
      try {
        const insertPosition = this.findInsertPositionInHTML(
          currentHTML, 
          highlight.text, 
          highlight.occurrenceIndex
        );
        
        if (insertPosition !== -1) {
          const newHTML = this.insertHighlightSpanAtPosition(
            currentHTML, 
            highlight.text, 
            insertPosition
          );
          
          if (newHTML !== currentHTML) {
            currentHTML = newHTML;
            console.log(`✓ Resaltado ${index + 1} aplicado`);
          }
        } else {
          console.warn(`⚠ No se pudo aplicar resaltado: "${highlight.text}"`);
        }
      } catch (error) {
        console.error(`Error en resaltado ${index + 1}:`, error);
      }
    });

    this.$set(this.textParagraphs[paragraphIndex], 'description', currentHTML);
    
  } catch (error) {
    console.error(`Error restaurando párrafo ${paragraphId}:`, error);
  }
},

    // Modificar raeSearch para usar la selección guardada en iOS
    raeSearch() {
      // Obtener la selección (del objeto guardado o directamente)
      let selection = window.getSelection();
      let selectedText = "";
      
      // Si hay una selección activa, usarla
      if (selection && !selection.isCollapsed) {
        selectedText = selection.toString().trim();
      } 
      // Si no hay selección activa pero tenemos una guardada (caso iOS)
      else if (this.currentSelection && this.currentSelection.text) {
        selectedText = this.currentSelection.text;
        console.log("Usando selección guardada para RAE:", selectedText);
      } 
      // No hay selección
      else {
        this.showSnackbar('Seleccione una palabra primero', 'orange');
        return;
      }

      if (selectedText.length === 0) {
        this.snackbar = true;
        this.color = "red";
        this.text = "Debe seleccionar una palabra.";
        return;
      }
      
      window.open(
        `https://dle.rae.es/${encodeURIComponent(selectedText)}?m=form`,
        "_blank",
        "width=600,height=600"
      );
      
      // Limpiar la selección guardada
      this.currentSelection = null;
    },

    // Modificar saveWord para usar la selección guardada en iOS
    saveWord() {
      // Obtener la selección (del objeto guardado o directamente)
      let selection = window.getSelection();
      let selectedText = "";
      
      // Si hay una selección activa, usarla
      if (selection && !selection.isCollapsed) {
        selectedText = selection.toString().trim();
      } 
      // Si no hay selección activa pero tenemos una guardada (caso iOS)
      else if (this.currentSelection && this.currentSelection.text) {
        selectedText = this.currentSelection.text;
        console.log("Usando selección guardada para guardar palabra:", selectedText);
      } 
      // En este caso, puede ser una llamada programática sin selección
      else if (this.canHighLight) {
        this.showSnackbar('Seleccione una palabra primero', 'orange');
        this.canHighLight = false;
        return;
      } else {
        return; // Salir silenciosamente si no hay selección y no es una acción explícita
      }

      if (selectedText.trim() !== "") {
        let count = 0;
        const words = selectedText.split(" ");
        
        words.find((data) => {
          if (data === "") count++;
        });
        
        if (this.canHighLight && words.length - count === 1) {
          if (this.searchWord(selectedText)) {
            this.canHighLight = false;
            this.snackbar = true;
            this.color = "orange";
            this.text = "Palabra: " + selectedText + " ya está guardada";
            return;
          }

          this.savedWords.push(selectedText);
          this.snackbar = true;
          this.text = "Palabra guardada con éxito.";
          this.color = "green";
          this.saveState(4);
        }
      }
      
      this.canHighLight = false;
      this.currentSelection = null;
    },

    showSnackbar(message, color) {
      this.snackbar = true;
      this.color = color || 'primary';
      this.text = message;
      
      // Opcionalmente, cerrar automáticamente después de un tiempo
      setTimeout(() => {
        this.snackbar = false;
      }, 3000);
    },
    startTimer() {
      console.log('start timer')

       // Detener cualquier intervalo previo si existe
        if (this.interval) {
          clearInterval(this.interval);
        }
        
      if (localStorage.getItem('activity_time_' + this.activityId)) {
        
        let timeData = JSON.parse(localStorage.getItem('activity_time_' + this.activityId));
        let limitTime = timeData.limitTime;
        let timePased = timeData.timePased;
        this.time = timePased;

        if (limitTime && timePased >= limitTime) {
          this.finish = true;
          this.tab = "tab-3";
          this.forceFinish = false;
          clearInterval(this.interval);
          this.forceFinish = true;
        }
      }

      this.interval = setInterval(async () => {
        
        if (localStorage.getItem('activity_time_' + this.activityId)) {
          let timeData = JSON.parse(localStorage.getItem('activity_time_' + this.activityId));
          let limitTime = timeData.limitTime;
          let timePased = timeData.timePased;
          this.time = timePased;
          const data = { limitTime: limitTime, timePased: timePased };
          if (this.finish || this.finishText) {
            this.time++;
          }
          data.timePased = this.time;
          localStorage.setItem('activity_time_' + this.activityId, JSON.stringify(data));

          if (data.limitTime && data.timePased >= data.limitTime) {
           
            this.finish = true;
            this.tab = "tab-3";
            clearInterval(this.interval);
            this.forceFinish = true;
          }
        } else {
          const data = { limitTime: Number(this.activity.activity.time) * 60 , timePased: this.time };
          localStorage.setItem('activity_time_' + this.activityId, JSON.stringify(data));
          if (this.finish || this.finishText) {
            this.time++;
          }
        }
      }, 1000);
    }
  },
  async created() {
    this.activityId = this.$route.params.id;

    await this.checkExistingReply();

    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleScroll); // Importante también manejar los cambios de tamaño
    this.handleScroll(); 


    // Obtener la actividad antes de cargar los textos
    const aux = await axios.get("student/activity/" + this.activityId);
    this.activity = aux.data;

    // Obtener el texto y párrafos asociados
    await this.getText();

    // Detectar si es dispositivo iOS
    this.detectIOS();
    
    // Si es iOS, agregar soporte adicional para selección de texto
    if (this.isIOS) {
      // Agregar CSS específico para iOS
      const style = document.createElement('style');
      style.textContent = `
        .highlightable-content {
          -webkit-user-select: text !important;
          user-select: text !important;
          cursor: text !important;
        }
      `;
      document.head.appendChild(style);
      
      // En iOS, también escuchar eventos de selección a nivel de documento
      document.addEventListener('selectionchange', this.handleSelection);
    }
    
    // Event Listener para guardar palabras e imágenes asociadas
    document.addEventListener("click", (event) => {
      const link = event.target.closest('.image-link');
      if (link) {
        event.preventDefault();
        const imageUrl = link.dataset.image;
        this.showImageModal(imageUrl);
      }
      if (event.target === this.$refs.target || event.target.contains(this.$refs.target)) {
        this.saveWord();
      }
    });

      // Cargar el estado guardado si existe
    await this.loadSavedProgress();

    // Iniciar el temporizador
    this.startTimer();
    this.saveState(5);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleScroll);    
    clearInterval(this.interval);
    // Limpiar listener de selección si es iOS
    if (this.isIOS) {
      document.removeEventListener('selectionchange', this.handleSelection);
    }
  }
};
</script>